import { isObservableProp, makeObservable } from "mobx";

const annotationsPropName = Symbol("annotationsPropName");

export function makeAutoObservableExt(object: any, type: any, annotations: Record<string, any> = {}) {
  if (!object[annotationsPropName]) {
    object[annotationsPropName] = {};
  }

  const autoAnnotations: Record<string, any> = object[annotationsPropName];

  const className = type.name;

  const getPrototype = () => {
    let prototype = Object.getPrototypeOf(object);
    while(prototype) {
      if (prototype.constructor.name === className) {
        return prototype;
      }
      prototype = Object.getPrototypeOf(prototype);
    }
    return null;
  }

  const propShouldBeSkipped = (propName: string) =>
    propName === 'constructor'
    || autoAnnotations[propName]
    || annotations[propName]
    || isObservableProp(object, propName);

  const prototype = getPrototype();

  if (prototype) {
    const prototypeProps = Object.getOwnPropertyNames(prototype);
    for(const propName of prototypeProps) {
      if (propShouldBeSkipped(propName)) {
        continue;
      }

      const descriptor = Object.getOwnPropertyDescriptor(prototype, propName);
      if (!descriptor) {
        continue;
      }

      autoAnnotations[propName] = true;
    }
  }

  object[annotationsPropName] = Object.assign(autoAnnotations, annotations);

  const objectConstructor = Object.getPrototypeOf(object).constructor.name;

  if (objectConstructor === type.name) {
    const props = Object.getOwnPropertyNames(object);
    for (const propName of props) {
      if (propShouldBeSkipped(propName)) {
        continue;
      }
      const descriptor = Object.getOwnPropertyDescriptor(object, propName);
      if (!descriptor) {
        continue;
      }

      autoAnnotations[propName] = true;
    }

    object[annotationsPropName] = Object.assign(autoAnnotations, annotations);
    makeObservable(object, object[annotationsPropName]);
    object[annotationsPropName] = undefined;
  }
}
